/// <reference path="_references.ts"/>

module App.Chat {
	export class ChatDirective {
		public templateUrl: string = 'html/chat/chat.html';
		public controllerAs: string = 'chat';
		public controller: string = 'ChatController';
		public replace: boolean = true;
	}
}
